class YouTubeVideo {
  constructor(el) {
    this.element = el;
    this.youTubeSource = this.element.dataset.youtubeurl;
    this.videoId = this.getVideoId()
    this.thumbnailIndex = this.element.dataset.thumbnailindex || 0;
    if (this.isImage()) {
      this.element.setAttribute('src', this.thumbnail());
    }
  }

  isImage() {
    return this.element.tagName == 'img';
  }

  getFrameData() {
    return {
      showTitle: this.element.dataset.showtitle || 0,
      showControls: this.element.dataset.showcontrols ? 1 : 0,
      playerId: this.element.id,
      rel: this.element.dataset.hiderelated ? 0 : 1
    }
  }

  getThumb(){
    return `http://img.youtube.com/vi/${this.videoId()}/${this.thumbnailIndex()}.jpg`;
  }

  getVideoId() {
    let matches = /(youtu(?:\.be|be\.com)\/(?:.*v(?:\/|=)|(?:.*\/)?)([\w'-]+))/i.exec(this.youTubeSource);

    if ((matches != null ? matches.length : undefined)) {
      return matches[matches.length - 1];
    }
    return this.youTubeSource;
  };
}

class YouTubeLoader {
  static load(frameOptions, global) {
    this.options = frameOptions || {};
    this.scope = global || window;
    this.dom = this.scope.document;
    this.iframesToLoad = [];
    for (let el of this.dom.querySelectorAll('[data-youtubeurl]')) {
      el.YouTubeVideo = new YouTubeVideo(el);
      if (!el.YouTubeVideo.isImage()) {
        this.iframesToLoad.push(el.YouTubeVideo);
      }
    }

    this.scope.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this);

    if (this.iframesToLoad.length > 0) {
      let frameAPI = this.dom.createElement('script');
      frameAPI.src = "https://www.youtube.com/iframe_api";
      this.dom.head.appendChild(frameAPI);
    }
  }
  static onYouTubeIframeAPIReady() {
    for (let video of this.iframesToLoad) {
      let opts = {"videoId": video.getVideoId()};
      opts.playerVars = Object.assign(video.getFrameData(), this.options);
      video.player = new YT.Player(video.element.id, opts);
    }
  }
}

export const Loader = YouTubeLoader;
export const Video = YouTubeVideo;
